import { createStore } from 'satcheljs';
import { ObservableMap } from 'owa-mobx4-adapter';
var getStore = createStore('publicFolderUtilsStore', new ObservableMap());
export default getStore;
//# sourceMappingURL=store.js.map